import {Vue} from '~/addiesaas'
import globalComponents from './global'
import cartComponents from './cart'
import pageComponents from '../pages'

const requires = {...globalComponents, ...pageComponents, ...cartComponents}
Object.values(requires).forEach(component => {
  Vue.component(component.name, component)
})

export default requires
